/* eslint-disable eqeqeq */

import { UsersApi } from '../../../api/UsersApi';
import { getIsDesktop, Pages } from '../../../utils/Utils';
import React, {useState, useRef} from 'react';
import { IMaskInput } from 'react-imask';

function FindExpertsPartner(props) {
    const [name, setName] = useState("")
    const [phoneNumber, setPhone] = useState("7")
    const ref = useRef(null)
    const inputRef = useRef(null)
    const isDesktop = getIsDesktop()

    var isPhoneEntered = phoneNumber.length == 11
    var isNameEntered = name.length > 1

    const onPhoneChange = (phone) => {
        if (phone == undefined || phone == ""){
            setPhone("")
            setPhone("7")
        } else {
            if (phone.length < 3){
                setPhone("7")
            } else {
                setPhone(phone)
            }
        }
    }
    const fastRequestRepetitor = () => {
        UsersApi.fastRequestRepetitor(props.searchText, phoneNumber, props.user.vk_caller_id, name, () => {
            if (props.showToast){
                props.showToast("Запрос успешно отправлен")
            }
        }, () => {

        })
       
    }
    return (
        <div style={isDesktop ? {width : 'calc(100% - 28px)', margin :'0 12px 16px 16px'} : {margin : '0 0 8px 0', width : '100%'}} className='experts_partner_container'>
            <div className='experts_partner_title'>Подбор репетитора без лишних хлопот</div>
            <div className='experts_partner_desc'>
                Оставьте свои контакты и персональный менеджер бесплатно подберёт для вас репетитора
            </div>
            <div className='experts_partner_inputs'>
                <input className='experts_partner_input experts_partner_inp_left' type='text' placeholder='Ваше имя' value={name} onChange={(e) => setName(e.target.value)}/>
                <IMaskInput type="tel" className="experts_partner_input experts_partner_inp_right" mask={'+{7} (000) 000-00-00'} radix="." value={phoneNumber} unmask={true} // true|false|'typed'
                    ref={ref}
                    inputRef={inputRef}
                    onAccept={
                        (value, mask) => {
                            onPhoneChange(value)
                            console.log("value = " + value)
                        }
                    } placeholder='+7 (000) 000-00-00' />
            </div>
            <div className='experts_partner_buttons'>
                <div onClick={fastRequestRepetitor} style={(isPhoneEntered && isNameEntered) ? {} : {pointerEvents : 'none', opacity : '0.2'}} className='experts_partner_btn hover'>Отправить заявку</div>
                <div className='experts_partner_policy'>Отправляя форму, я подтверждаю, что мне есть 18 лет, и я соглашаюсь с <a rel="noreferrer" target='_blank' href={Pages.terms} className='experts_partner_underline hover'>Условиями использования</a> и <a rel="noreferrer" target='_blank' href={Pages.privacy_policy} className='experts_partner_underline hover'>Политикой конфиденциальности</a></div>

            </div>
        </div>
    );
}


export default FindExpertsPartner;
